<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import fakeClickOutSide from '@/utils/mixins';

export default {
  name: 'App',
  mixins: [fakeClickOutSide]
};
</script>
